import { Injectable } from '@angular/core';
import { Cert, Certinfo } from '../../../api';

@Injectable({
  providedIn: 'root'
})
export class CertLoadedService {

  /**
   * String that contains the actual name of the cert
   */
  certLoaded: string = '';

  /**
   * Object that obtains the actual object of cert
   */
  completeCert: Cert;

  /**
   * Object that obtains the parsed cert
   */
  parseCert: Certinfo;

  /**
   * String that contains the actual token
   */
  tokenCert: string = '';


  public setNameCert(cert){
    this.certLoaded = cert;
  }

  public getNameCert(){
    return this.certLoaded;
  }

  public setCompleteCert(cert){
    this.completeCert = cert;
  }

  public getCompleteCert(){
    return this.completeCert;
  }

  public setParseCert(cert){
    this.parseCert = cert;
  }

  public getParseCert(){
    return this.parseCert;
  }

  public setTokenCert(token){
    this.tokenCert = token;
  }

  public getTokenCert(){
    return this.tokenCert;
  }

  public clearTokenCert(){
    this.tokenCert = '';
    return this.tokenCert;
  }

  public resetConfig(){
    this.tokenCert = '';
    this.parseCert = null;
    this.completeCert = null;
    this.certLoaded = null;
  }

}
